module.exports = __webpack_public_path__ + "img/Q60B.60b797ef.png";